<template>
  <div>
    <div class="printer-document-content-block__editor-label" v-if="block.label">
      {{ block.label }}
    </div>
    <EditorCard
      class="printer-document-content-block__editor-card"
      :data="block.basicData"
      readonly />
  </div>
</template>

<script>
import { PrinterDocumentContentBlock } from '@/models/client/PrinterDocumentContentBlock.model';
import EditorCard from '@/components/EditorCard/index.vue';

export default {
  name: 'PrinterDocumentContentBlockEditor',
  components: { EditorCard },
  props: {
    block: [PrinterDocumentContentBlock, Object],
  },
};
</script>

<style lang="scss" src="./index.scss"></style>
